export default {"src":"/_next/static/media/check-icon.0b08aa58.svg","height":10,"width":14};